/**
 * Hands the browser a file to save. Kept apart from the interactors that produce the
 * bytes: object URLs and synthetic anchor clicks do not exist in jsdom, so anything
 * that calls this is untestable, and there should be as little of it as possible.
 */
export function downloadBytes(bytes: Uint8Array, fileName: string, mimeType: string): void {
    const blob = new Blob([bytes as unknown as BlobPart], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    URL.revokeObjectURL(url);
}
